const API_BASE = process.env.REACT_APP_API_URL || 'https://solved-financial-api.applore.in/api';

export default API_BASE;
